import { DynamicImportRetry } from './DynamicImportRetry';
import type { RetryConfig } from './RetryConfig';
import { DEFAULT_RETRY_CONFIG } from './RetryConfig';

interface CreateRetryOptions {
  importFunction?: (path: string) => Promise<any>;
}

export default function createDynamicImportWithRetry(
  maxRetries: number,
  opts: CreateRetryOptions = {},
): <TImportReturn>(
  importer: () => Promise<TImportReturn>,
) => Promise<TImportReturn> {
  if (maxRetries <= 0 || !Number.isInteger(maxRetries)) {
    throw new Error(`maxRetries must be a positive integer, got: ${maxRetries}`);
  }

  const config: RetryConfig = {
    ...DEFAULT_RETRY_CONFIG,
    maxRetries,
    importFunction: opts.importFunction || DEFAULT_RETRY_CONFIG.importFunction,
  };

  const retryHandler = new DynamicImportRetry(config);

  return <TImportReturn>(
    importer: () => Promise<TImportReturn>,
  ): Promise<TImportReturn> => {
    return retryHandler.executeWithRetry(importer);
  };
}

// Export classes for advanced usage
export { DynamicImportRetry } from './DynamicImportRetry';
export { ChunkErrorSessionManager } from './ChunkErrorSessionManager';
export { ChunkErrorRecovery } from './ChunkErrorRecovery';
export { extractModulePathFromImporter } from './RetryStrategies';
export type { RetryConfig } from './RetryConfig';